import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { observable, autorun } from 'mobx'
import { debounce, autobind } from 'core-decorators'
import { inject, observer } from 'mobx-react'
import { withRouter } from 'react-router'

import Error from '../../shared/components/Error'
import Loader from '../../shared/components/Loader'
import Form from '../components/Form'
import syncTransaction from '../../shared/syncTransaction'

@inject('user', 'auth')
@observer
class FormContainer extends Component {

  /* eslint-disable react/sort-comp */
  @observable isSaving = null

  @observable error = null
  /* eslint-enable react/sort-comp */

  static propTypes = {
    auth: PropTypes.object.isRequired,
    children: PropTypes.oneOfType([
      PropTypes.arrayOf(PropTypes.node),
      PropTypes.node,
    ]),
    params: PropTypes.shape({
      id: PropTypes.string,
    }),
    router: PropTypes.shape({
      push: PropTypes.func.isRequired,
    }).isRequired,
    user: PropTypes.object.isRequired,
  }

  constructor(props) {
    super(props)
    this.load(props)
    autorun(() => {
      if (this.props.user.current && this.props.user.current.identification) {
        this.ensureUniqueUser()
      }
    })
  }

  @debounce(500)
  ensureUniqueUser() {
    const { current } = this.props.user
    if (current && current.identification) {
      const login = current.identification.login
      const origLogin = current.origLogin

      if (login && typeof login === 'string' && login.length > 2 && login !== origLogin) {

        current.setValid('unique', {
          field: 'identification.login',
          state: {
            valid: false,
            // fake promise
            errors: [{
              type: 'Benutzername wird auf Einzigartigkeit geprüft...'
            }]
          }
        })

        this.props.user.where({
          'identification.login': login
        }, {
          silent: true
        })
          .then((result) => {
            const valid = result.models.length === 0
            const errors = valid
              ? null
              : [{ type: `Es existiert bereits ein Nutzer mit dem Benutzername \`${login}\`! Bitte einen anderen Benutzername vergeben.` }]
            current.setValid('unique', {
              field: 'identification.login',
              state: {
                valid,
                errors
              }
            })
          })
      }
    }
  }

  componentWillReceiveProps(nextProps) {
    this.load(nextProps)
  }

  load({ user, params: { id } }) {
    if (!id) {
      user.setCurrent(user.createModel())
    }
    else {
      user.openById(id)
    }
  }

  @autobind
  handleClose() {
    // On close go back to startpage as defined in #65
    this.props.router.push('/')
  }

  @autobind
  handleCancel() {
    this.handleClose()
  }

  @autobind
  handleDelete(model) {
    return this:: syncTransaction(model.destroy())
  }

  @autobind
  handleSave(model) {
    return this:: syncTransaction(model.save())
  }

  render() {

    const {
      auth, user, user: { current }, params: { id }
    } = this.props

    if (user.loading) {
      return <Loader>Daten werden geladen</Loader>
    }

    if (!this.props.auth.user) {
      return <Loader>Auf Nutzer warten...</Loader>
    }

    if (!current || (current.id && current.id !== id * 1)) {
      return <Error>Fehler beim Laden</Error>
    }

    const mayEditBaseData = !!(auth.acs.isAuthorized('SUPERADMIN')
      || auth.acs.isAuthorized('ADMIN'))

    return (
      <Form
        mayEditBaseData={mayEditBaseData}
        current={current}
        onCancel={this.handleCancel}
        onDelete={this.handleDelete}
        onSave={this.handleSave}
        isBusy={this.isSaving}
      />
    )
  }
}

const FormContainerWithRouter = withRouter(FormContainer)

export { FormContainerWithRouter as default }



// WEBPACK FOOTER //
// ./src/user/containers/Form.js